import Actions from './Actions'
import I18n from './../lib/i18n'

export default class LocaleActions extends Actions{
    static get target(){
        return 'locale'
    }
    
    static setLocale(locale) {
        this.set(locale)
    }
    static translate(key) {
        const i18n = new I18n
        i18n.setLocale(this.value || "en")
        return i18n.translate(key)
    }
}


// WEBPACK FOOTER //
// ./actions/LocaleActions.js